import request from '@/utils/request'

// 获取用户列表
export function getList(params) {
  const { page: current, limit: size, ...otherWhere } = params
  const wherePrefix = 'eq_su.'
  const payload = {
    page: { current, size },
    where: Object.assign({}, ...Object.keys(otherWhere).map((key) => ({ [wherePrefix + key]: otherWhere[key] })))
  }
  payload.where["asc_su.createTime"] = "1"
  return request.post('/sys/user/getPage', payload).then(({ data }) => {
    const { page, ...otherData } = data
    const { records, total } = page
    return { data: { ...otherData, data: { items: records, total } } }
  })
}

const converStaffData = (data) => {
  const { role, id, phone, remark, ...otherData } = data
  return {
    id,
    userId: id,
    mobile: phone,
    roleIdList: role,
    description: remark,
    ...otherData,
  }
}

// 创建用户信息
export function createOne(data) {
  return request.post('/sys/user/save', converStaffData(data))
}

// 更新用户信息
export function updateOne(data) {
  return request.post('/sys/user/update', converStaffData(data))
}

// 删除用户信息
export function deleteOne(data) {
  return request.post('/sys/user/delete/' + data.id)
}


// 上传人脸信息
export function createWhiteOne(data, id) {
  const url = '/personOrder/face/' + id
  return request.post(url, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 删除人脸信息
export function deleteWhiteOne(data) {
  const url = '/personOrder/delete/' + data.personOrderId
  return request.get(url)
}

// 绑定企业微信
export function bindOne(params) {
  return request.get('/sys/user/bindWechat', { params })
}